(ns app.strive-forms.question-fields.grid-field
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?
                                                              update-question-input-data update-question-input-local]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [process-response-all-fields!
                                                       set-values-for-button!]]
            [app.strive-forms.styles :refer [number-scale-label-style
                                             number-scale-labels-component-style
                                             numbers-scale-component-style]]
            [re-com.box :refer [gap]]
            [re-com.core :refer [v-box]]
            [re-com.radio-button :as radio-button]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))
(defmethod show-action-btn? "grid_question" [props]
  true)

(defmethod update-question-input-local "grid_question" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "grid_question" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))
(defn- width-for-number-button [count-of-buttons]
  (let [galaxy-fold-conditions (< (.-innerWidth js/window) 290)
        galaxy-s8-conditions (and (> (.-innerWidth js/window) 290) (< (.-innerWidth js/window) 370))
        regular-phone-view-conditions (and (> (.-innerWidth js/window) 370) (< (.-innerWidth js/window) 800))]
    (cond galaxy-fold-conditions (str (/ 100 4.54) "%")
          galaxy-s8-conditions (str (/ 100 6) "%")
          regular-phone-view-conditions (str (/ 100 7) "%")
          :else (str (/ 100 count-of-buttons) "%"))))

(defn sub-question-radio-group [{:keys [item question_type enable_na grid-question-value]}]
  (let [item-value (r/atom nil)]
    (fn [{:keys [grid-question-value input-data field-id regenerate-display-fields]}]
      [:div {:style {:display "flex" :width "100%"}}
       (when (= question_type "one_five")
         (doall (for [x (range 1 6)]
                  ^{:key x}
                  [radio-button/radio-button
                   :label ""
                   :value       x
                   :model       item-value
                   :on-change  (fn [value]
                                 (reset! item-value value)
                                 (reset! grid-question-value (update @grid-question-value 
                                                                     (keyword (:value item)) 
                                                                     #(when (not= % value) value)))
                                 (process-response-all-fields! {:input-data input-data :field-id field-id
                                                                :regenerate-display-fields regenerate-display-fields
                                                                :input-value (.stringify js/JSON (clj->js @grid-question-value))})
                                 )
                   :parts {:wrapper {:style {:width (width-for-number-button 6)
                                             :justify-content "center"}}} 
                   ])))
       (when enable_na
         [radio-button/radio-button
          :label ""
          :value       -1
          :model       item-value
          :on-change  (fn [value]
                        (reset! item-value value)
                        (reset! grid-question-value (update @grid-question-value 
                                                            (keyword (:value item))
                                                            #(when (not= % value) value)))
                         (process-response-all-fields! {:input-data input-data :field-id field-id
                                                        :regenerate-display-fields regenerate-display-fields
                                                        :input-value (.stringify js/JSON (clj->js @grid-question-value))}))
          :parts {:wrapper {:style {:width (width-for-number-button 6)
                                    :justify-content "center"}}}])])))


(defn grid-question [{:keys [field ]}]
  (let [enable_na (:enable_na (:additional_settings field))
        question-type (:question_type (:additional_settings field))
        sub-questions (:sub_questions (:additional_settings field))
        grid-question-value (r/atom (into {} (map (fn [item] {(keyword (:value item)) nil}) sub-questions)))]
    (fn [{:keys [field field-id index selected-language field-id index input-value selected-language theme-data form-messages current-page input-data on-submit pre-filled regenerate-display-fields hidden-fields display-fields is-multi-question?]}]
      (let [min-value-label (when-not (nil? ((keyword selected-language) (:minimum_label_obj (:additional_settings field))))
                              ((keyword selected-language) (:minimum_label_obj (:additional_settings field))))
            max-value-label (when-not (nil? ((keyword selected-language) (:maximum_label_obj (:additional_settings field))))
                              ((keyword selected-language) (:maximum_label_obj (:additional_settings field))))]
        (println (str "input" @input-value))
        (add-watch grid-question-value :watcher
                   #(do (println(str "grid" @grid-question-value))
                      (set-values-for-button! {:input-value input-value :component-input-value grid-question-value
                                               :field-id field-id :type (:type field)})))
        [v-box
         :justify :center
         :width "100%"
         :align :center
         :children [(when (= question-type "one_five")
                     
                       [:div
                        {:class (number-scale-labels-component-style {:width "486px"
                                                                      :color (:answers_color theme-data)
                                                                      :align-self "start"})
                         :id (str "number-scale-label" (:id field))
                         :style {:margin-left "225px"}}
                        
                        [:p {:class (number-scale-label-style {:font-size (if is-multi-question? "12px" "16px")})} min-value-label]
                        [:p {:class (number-scale-label-style {:font-size (if is-multi-question? "12px" "16px")})} max-value-label]]
                       )
                    [:div
                     {:class (numbers-scale-component-style {:width (if (< (.-innerWidth js/window) 800)
                                                                      (str (- 100 (/ 100 7)) "%")
                                                                      "736px")
                                                             :flex-wrap (when (< (.-innerWidth js/window) 800) "wrap")})
                      :id (str  "number-scale-" (:id field))}
                     [gap :size "200px"]
                     (doall (for [x (range 1 6)]
                              [:div
                               {:style {:width (width-for-number-button 6)
                                        :text-align "center"}}
                               [:p {:style {:font-size (if is-multi-question? "12px" "16px")}} x]]))

                     (when enable_na [:div
                                      {:style {:width (width-for-number-button 6)
                                               :text-align "center"}}
                                      [:p {:style {:font-size (if is-multi-question? "12px" "16px")}} "N/A"]])]
                    (map (fn [sub-question]
                           [:div {:style {:display "flex" :justify-content "center" :align-items "center" :width "736px"}}
                            [:p {:style {:font-size (if is-multi-question? "12px" "16px") :width "295px"}}
                             ((keyword selected-language) (:option_texts sub-question))]
                            [sub-question-radio-group {:item sub-question :question_type question-type :enable_na enable_na :grid-question-value grid-question-value
                                                       :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields}]]) sub-questions)]]))))